"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _calendrical = _interopRequireDefault(require("calendrical"));

var _moment = _interopRequireWildcard(require("moment"));

var _Definition = _interopRequireDefault(require("../Definition"));

var _Bar = _interopRequireDefault(require("../Bar"));

var _Button = _interopRequireDefault(require("../Button"));

var _Buttons = _interopRequireDefault(require("../Buttons"));

var _Layout = require("../Layout");

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _arrowPrev = _interopRequireDefault(require("../icons/arrow-prev.svg"));

var _arrowNext = _interopRequireDefault(require("../icons/arrow-next.svg"));

var _config = require("../config/config");

var _momentPropType = _interopRequireDefault(require("../_utils/momentPropType"));

var _constants = require("./constants");

require("./calendar.sass");

var _CalendarContext = _interopRequireDefault(require("./CalendarContext"));

// This lib is not supported
var _ref2 = _react.default.createElement(_Spinner.default, null);

var Calendar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Calendar, _Component);

  function Calendar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      view: _this.props.defaultView
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "yearViewMonthPerLines", 4);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "today", (0, _moment.default)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderDay", function (_ref, index) {
      var date = _ref.date,
          inCurrentMonth = _ref.inCurrentMonth;

      if (!inCurrentMonth) {
        return _react.default.createElement("div", {
          className: "calendar-day",
          key: index
        });
      }

      date = (0, _moment.default)(date);

      var filtered = _react.default.Children.toArray(_this.props.children).filter(function (child) {
        return child && child.props && date.isSame(child.props.date, 'day');
      });

      var children = _this.sortChildren(filtered).map(function (child, key) {
        return _react.default.cloneElement(child, {
          key: key
        });
      });

      return _react.default.createElement("div", {
        className: "calendar-day",
        key: index
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)('calendar-day-number', {
          'calendar-day-number--today': _this.today.isSame(date, 'day')
        })
      }, date.format('D')), children);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderWeek", function (week, index) {
      return _react.default.createElement("div", {
        className: "calendar-week",
        key: index
      }, week.map(_this.renderDay));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handlePrev", function () {
      var _this$props = _this.props,
          date = _this$props.date,
          onSelectDate = _this$props.onSelectDate;
      var view = _this.state.view;
      onSelectDate((0, _moment.default)(date).subtract(1, view).toDate(), view);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleToday", function () {
      var onSelectDate = _this.props.onSelectDate;
      var view = _this.state.view;
      onSelectDate(new Date(), view);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleNext", function () {
      var _this$props2 = _this.props,
          date = _this$props2.date,
          onSelectDate = _this$props2.onSelectDate;
      var view = _this.state.view;
      onSelectDate((0, _moment.default)(date).add(1, view).toDate(), view);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleTitleClick", function () {
      var _this$props3 = _this.props,
          onSelectDate = _this$props3.onSelectDate,
          date = _this$props3.date;

      if (_this.state.view === _constants.MONTH) {
        _this.setState({
          view: _constants.YEAR
        });

        onSelectDate((0, _moment.default)(date).toDate(), _constants.YEAR);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "applyMonthView", function (month) {
      var onSelectDate = _this.props.onSelectDate;
      onSelectDate(month.toDate(), _constants.MONTH);

      _this.setState({
        view: _constants.MONTH
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "sortChildren", function (items) {
      var sort = _this.props.sort;

      switch (sort) {
        case _constants.REVERSE:
          items = items.sort(function (left, right) {
            return (0, _moment.default)(left.props.date).isBefore(right.props.date) ? 1 : -1;
          });
          break;

        case _constants.DISABLED:
          break;

        default:
          items = items.sort(function (left, right) {
            return (0, _moment.default)(left.props.date).isAfter(right.props.date) ? 1 : -1;
          });
      }

      return items;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderMonthInYear", function (month) {
      var lol = _react.default.Children.toArray(_this.props.children);

      var filtered = lol.filter(function (child, i) {
        return child && child.props && (0, _moment.default)(child.props.date).isSame(month, 'month');
      });

      var children = _this.sortChildren(filtered).map(function (child, key) {
        return _react.default.cloneElement(child, {
          key: key
        });
      });

      var isCurrentYear = _this.today.isSame(month, 'year');

      var isCurrentMonth = _this.today.isSame(month, 'month');

      var isActive = isCurrentMonth && isCurrentYear;
      var className = (0, _classnames.default)('calendar-year-monthPerYear', {
        'calendar-year-monthPerYear--active': isActive
      });
      return _react.default.createElement("div", {
        key: "month-".concat(month.month()),
        className: className
      }, _react.default.createElement("h3", {
        className: "calendar-year-monthPerYear-title",
        onClick: function onClick() {
          return _this.applyMonthView(month);
        }
      }, _react.default.createElement("span", {
        className: "calendar-year-monthPerYear-title-entry"
      }, month.format('MMMM'))), _react.default.createElement("div", {
        className: "calendar-year-monthPerYear-content"
      }, children));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderYear", function () {
      var date = _this.props.date;

      var fillMonth = function fillMonth(title, index) {
        return (0, _moment.default)(date).month(index);
      };

      var month = _moment.default.months().map(fillMonth);

      return _react.default.createElement(_Layout.ScrollView, null, _react.default.createElement("div", {
        className: "calendar-year"
      }, month.map(_this.renderMonthInYear)));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderContent", function () {
      var view = _this.state.view;

      switch (view) {
        case _constants.MONTH:
          return _this.renderMonth();

        case _constants.YEAR:
        default:
          return _this.renderYear();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderTitleButton", function () {
      var date = _this.props.date;

      switch (_this.state.view) {
        case _constants.MONTH:
          return _react.default.createElement(_Definition.default, {
            title: (0, _moment.default)(date).format('MMMM'),
            detail: (0, _moment.default)(date).format('YYYY')
          });

        case _constants.YEAR:
        default:
          return (0, _moment.default)(date).format('YYYY');
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "additionToBar", function () {
      var additionToBar = _this.props.additionToBar;
      return additionToBar ? additionToBar : null;
    });
    return _this;
  }

  (0, _createClass2.default)(Calendar, [{
    key: "renderDayNames",
    value: function renderDayNames() {
      if (this.state.view === _constants.YEAR) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "calendar-week calendar-week--dayNames"
      }, new Array(7).fill(0).map(function (_, key) {
        return _react.default.createElement("span", {
          className: "calendar-day",
          key: key
        }, (0, _moment.default)().weekday(key).format('dd'));
      }));
    }
  }, {
    key: "renderMonth",
    value: function renderMonth() {
      var date = this.props.date;

      var month = _calendrical.default.getWeeksInMonth((0, _moment.default)(date).toDate());

      return _react.default.createElement(_Layout.ScrollView, null, _react.default.createElement("div", {
        className: "calendar-month"
      }, month.map(this.renderWeek)));
    }
  }, {
    key: "render",
    value: function render() {
      var isLoading = this.props.isLoading;
      var view = this.state.view;
      return _react.default.createElement("div", {
        className: "calendar"
      }, _react.default.createElement(_Bar.default, {
        className: "calendar-header"
      }, _react.default.createElement(_Button.default, {
        disabled: this.isToday,
        onClick: this.handleToday
      }, (0, _config.__)('Today')), _react.default.createElement(_Buttons.default, null, _react.default.createElement(_Button.default, {
        onClick: this.handlePrev,
        Icon: _arrowPrev.default
      }), _react.default.createElement(_Button.default, {
        onClick: this.handleTitleClick,
        className: "calendar-header-title",
        disabled: this.state.view === _constants.YEAR
      }, this.renderTitleButton()), _react.default.createElement(_Button.default, {
        onClick: this.handleNext,
        Icon: _arrowNext.default
      })), this.additionToBar()), isLoading ? _ref2 : this.renderDayNames(), _react.default.createElement(_CalendarContext.default.Provider, {
        value: {
          view: view
        }
      }, !isLoading && this.renderContent()));
    }
  }, {
    key: "isToday",
    get: function get() {
      var date = this.props.date;
      var view = this.state.view;
      var currentDate = new Date();
      return (0, _moment.default)(date).isSame(currentDate, view);
    }
  }]);
  return Calendar;
}(_react.Component);

exports.default = Calendar;
(0, _defineProperty2.default)(Calendar, "defaultProps", {
  defaultView: _constants.YEAR,
  date: new Date()
});
Calendar.propTypes = process.env.NODE_ENV !== "production" ? {
  date: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _momentPropType.default]),
  isLoading: _propTypes.default.bool,
  onSelectDate: _propTypes.default.func.isRequired,
  defaultView: _propTypes.default.oneOf([_constants.YEAR, _constants.MONTH]),
  additionToBar: _propTypes.default.node,
  sort: _propTypes.default.oneOf([_constants.REVERSE, _constants.DISABLED])
} : {};